// in src/posts.js
import React from 'react'
import {
  List,
  Datagrid,
  ChipField,
  TextField,
  ReferenceManyField,
  SingleFieldList,
  translate,
} from 'admin-on-rest'
import { Link } from 'react-router-dom'

import RaisedButton from 'material-ui/RaisedButton'
import { createHashHistory } from 'history'
const history = createHashHistory()

const StudentsCoursesInProgressList = props => {
  // console.log('courses in progress', props)
  return (
    <div>
      <List {...props} title={'Cursuri in desfasurare'}>
        <Datagrid key="id">
          <CourseTitle label="Denumire curs" />
          <TextField label="Credite" source="credits" />
          <ReferenceManyField
            label="Lector"
            reference="instructors"
            target="courses"
            allowEmpty
          >
            <SingleFieldList>
              <ChipField source="displayName" />
            </SingleFieldList>
          </ReferenceManyField>
        </Datagrid>
      </List>
    </div>
  )
}

const CourseTitle = ({ record, push }) => (
  <Link to={`course/in-progress/${record.id}`}>{record.name}</Link>
)

export default translate(StudentsCoursesInProgressList)



// WEBPACK FOOTER //
// ./src/students/StudentsCoursesInProgressList.js